import { rc } from "./rc";

export const employee_voice_data_warnings = {
  rc,
};
